import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { Label } from './Label'
import styles from './Switch.module.css'

interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  info?: ReactNode
  infoTitle?: string
}

export const Switch = forwardRef<HTMLInputElement, SwitchProps>(
  ({ label, info, infoTitle = 'Info', id, ...props }, ref) => {
    const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
    return (
      <label className={styles['label']}>
        <input
          ref={ref}
          id={inputId}
          type="checkbox"
          className={styles['input']}
          {...props}
        />
        <Label info={info} infoTitle={infoTitle}>
          {label}
        </Label>
        <span className={styles['track']}>
          <span className={styles['thumb']} />
        </span>
      </label>
    )
  },
)
Switch.displayName = 'Switch'
